import { Button, Col, DatePicker, Image, Input, Select, Space, Typography } from "antd";
import { SearchOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import calendarImg from "../../../assets/images/nurseIcons/calender.svg";
import inputStyles from "../../../styles/Custom/Input.module.css";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const FinalDischargeFiltersRow = ({
  facilityAdmin,
  today,
  date,
  facilityData,
  currentFacility,
  handleFacilityChange,
  singleFacilityName,
  searchText,
  setSearchText,
  loading,
  onDateChange,
  handleExport,
}) => (
  <>
    {!facilityAdmin && (
      <Col>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Facility</div>
        {singleFacilityName ? (
          <Typography.Text
            style={{
              display: "inline-block",
              padding: "6px 12px",
              borderRadius: 6,
              background: "#f5f5f5",
              fontWeight: 500,
            }}
          >
            {singleFacilityName}
          </Typography.Text>
        ) : (
          <Select
            value={currentFacility}
            options={facilityData}
            onChange={handleFacilityChange}
            style={{ width: 150 }}
            size="large"
            loading={loading}
          />
        )}
      </Col>
    )}

    <Col xs={24} sm={12} md={8} lg={6}>
      <div style={{ marginBottom: 8, fontWeight: 500 }}>Start Date & End Date</div>
      <RangePicker
        style={{
          color: "black",
          border: "1px solid #a182e3",
          height: "38px",
        }}
        disabledDate={(current) => current && current.isAfter(today, "day")}
        className={inputStyles.mdDateInput}
        onChange={onDateChange}
        allowClear={false}
        value={[
          date?.from_date ? dayjs(date.from_date) : null,
          date?.to_date ? dayjs(date.to_date) : null,
        ]}
        suffixIcon={<Image width={20} src={calendarImg} preview={false} />}
        loading={loading}
      />
    </Col>

    <Col flex="auto" />

    <Col>
      <Input
        placeholder="Search records"
        prefix={<SearchOutlined />}
        style={{
          width: 220,
          marginTop: 24,
          borderRadius: 8,
        }}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        allowClear
      />
    </Col>

    <Col>
      <Space style={{ marginTop: 24 }}>
        <Button
          icon={<CloudDownloadOutlined />}
          style={{
            background:
              "color-mix(in srgb, var(--ant-primary-color) 10%, white)",
            color: "var(--ant-primary-color)",
            border: 0,
            borderRadius: 8,
            fontWeight: 500,
          }}
          onClick={() => handleExport("xlsx")}
          loading={loading}
        >
          Excel
        </Button>
      </Space>
    </Col>
  </>
);

export default FinalDischargeFiltersRow;
